import React from "react";
import { IFile } from "src/features/fileManagement/data/models/file";
import { IFolder } from "src/features/fileManagement/data/models/folder";
import { Assets } from "src/utils/assets";
import { DropdownPosition } from "../pages/fileManagementPage";

import fileBlankImage from "../../../../../assets/images/file_management/file_blank_image.webp";

interface FileComponentProps {
  file: IFile;
  toggleDropdown: (dropdownPosition: DropdownPosition) => void;
  handleSelectItem: (item: IFolder | IFile) => void;
  handleSelectFile: (file: IFile) => void;
  handlePreviewImage: (file: IFile) => void;
  isSelected: boolean;
}

interface FileComponentState {
  imageError: boolean;
}

class FileComponent extends React.Component<FileComponentProps, FileComponentState> {
  constructor(props: any) {
    super(props);

    this.state = {
      imageError: false,
    };
  }

  handleToggleDropdown = (event: any) => {
    const dropdownElement = document.getElementById("dropdown-action");

    const mouseTop = event.pageY;
    const mouseBottom = document.body.offsetHeight - event.pageY;
    const mouseLeft = event.pageX;
    const mouseRight = document.body.offsetWidth - event.pageX;

    const dropdownPosition: DropdownPosition = {
      top: mouseTop,
      left: mouseLeft,
    };

    if (document.body.offsetWidth - event.clientX < dropdownElement?.offsetWidth!) {
      delete dropdownPosition.left;
      dropdownPosition.right = mouseRight;
    }
    if (document.body.offsetHeight - event.clientY < dropdownElement?.offsetHeight!) {
      delete dropdownPosition.top;
      dropdownPosition.bottom = mouseBottom;
    }

    this.props.handleSelectItem(this.props.file);
    this.props.toggleDropdown(dropdownPosition);
  };

  handleLoadImageError = () => {
    this.setState({ imageError: true });
  };

  render() {
    let imageSrc = Assets.gallery;
    const isComnet = this.props.file.source === "comnet";

    if (this.props.file.mime_type?.includes("image")) imageSrc = this.props.file.url;
    else imageSrc = fileBlankImage;

    return (
      <div className={`grid-item`}>
        {!isComnet && (
          <img
            className={`select-box`}
            src={this.props.isSelected ? Assets.boxActive : Assets.boxInActive}
            alt=""
            width={30}
            onClick={() => this.props.handleSelectFile(this.props.file)}
          />
        )}
        {!isComnet && <span className="dropdown-dots" onClick={this.handleToggleDropdown} />}
        <div
          className="grid-item-container"
          onClick={() =>
            isComnet ? this.props.handlePreviewImage(this.props.file) : this.props.handleSelectItem(this.props.file)
          }
        >
          <div className="grid-head">
            <div className="file-image">
              {!this.state.imageError ? (
                <img
                  src={imageSrc}
                  alt=""
                  width={100}
                  style={{ alignSelf: "center" }}
                  onError={this.handleLoadImageError}
                />
              ) : (
                <img
                  src={fileBlankImage}
                  alt=""
                  width={100}
                  style={{ alignSelf: "center" }}
                  onError={this.handleLoadImageError}
                />
              )}
              {(imageSrc === fileBlankImage || this.state.imageError) && (
                <span className="file-extension">{this.props.file.extension.toUpperCase()}</span>
              )}
            </div>
          </div>
          <span className="file-name">{this.props.file.name}</span>
        </div>
      </div>
    );
  }
}

export default FileComponent;
